module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/designation/designation.component.html
// module id = ./src/app/Pages/manage/designation/designation.component.html
// module chunks = main